// extracted by mini-css-extract-plugin
export default {"header":"EventOfferType_header__M8kGV","wrapper":"EventOfferType_wrapper__njBgg","name":"EventOfferType_name__+rbeg","description":"EventOfferType_description__8UzMn"};